import {Injectable} from '@angular/core';
import * as signalR from "@microsoft/signalr";
import {environment} from "@numizmat/environments";

@Injectable({
  providedIn: 'root'
})
export class AdHubService {
  private adId?: string;
  public hubConnection!: signalR.HubConnection;

  constructor() {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .configureLogging(signalR.LogLevel.Information)
      .withUrl(environment.adHubUrl)
      .build();
  }

  public async startConnection(): Promise<void> {
    if (this.hubConnection.state === signalR.HubConnectionState.Disconnected) {
      return this.hubConnection.start();
    } else {
      return Promise.resolve();
    }
  }

  public async addToGroup(adId: string): Promise<void> {
    this.adId = adId;
    if (this.hubConnection.state === signalR.HubConnectionState.Connected) {
      return this.hubConnection.invoke('AddToGroup', adId).then();
    }
    return Promise.resolve();
  }

  public async stopConnection(): Promise<void> {
    if (this.hubConnection.state === signalR.HubConnectionState.Connected) {
      return this.hubConnection.stop().then();
    } else {
      return Promise.resolve();
    }
  }

  public async removeFromGroup(): Promise<void> {
    if (this.hubConnection.state === signalR.HubConnectionState.Connected && this.adId) {
      return this.hubConnection.invoke('RemoveFromGroup', this.adId).then();
    }
    return Promise.resolve();
  }

  public onReceiveNotification(callback: (data: any) => void): void {
    this.hubConnection.on("ReceiveNotification", (data: any) => {
      callback(data);
    });
  }

  public offReceiveNotification(): void {
    return this.hubConnection.off("ReceiveNotification");
  }
}
